import { useEffect } from "react";

import { SplashContainer, Website } from "./Splash.styles";

import { JagadLogo } from "@components/JagadLogo/JagadLogo";
import BetaLabel from "@components/BetaLabel/BetaLabel";
import { useNavigate } from "react-router";
import { useAuth } from "../../contexts/AuthContext";
import DialogOptionBox from "@components/DialogOptionBox/DialogOptionBox";
import { useState } from "react";
import { redirectToTelegramSupport, versionCompare } from "@lib/utils";
import { getPlatform, APIVersion, MINIMUM_WEBAPP_VERSION, DeviceStorage, SecureStorage, setHeaderColor } from "@lib/telegram";
import { useTranslation } from "react-i18next";
import { TELEGRAM_IOS_APP_URL, TELEGRAM_ANDROID_APP_URL, TELEGRAM_APPS } from "@constants/telegram";
import { BLACK } from "@styles/colors";

const SplashScreen = () => {
  const { t } = useTranslation()
  const TELEGRAM_VERSION_UNSUPPORTED = t('errors.4.title')
  const TELEGRAM_VERSION_UNSUPPORTED_DESCRIPTION = t('errors.4.description')
  const TELEGRAM_VERSION_UNSUPPORTED_ACTION = t('errors.4.action')

  const TELEGRAM_CLIENT_UNSUPPORTED = t('errors.5.title')
  const TELEGRAM_CLIENT_UNSUPPORTED_DESCRIPTION = t('errors.5.description')
  const TELEGRAM_CLIENT_UNSUPPORTED_ACTION = t('errors.5.action')

  const UNSUPPORTED_TELEGRAM_PROMPT = {
    client: {
      title: TELEGRAM_CLIENT_UNSUPPORTED,
      description: TELEGRAM_CLIENT_UNSUPPORTED_DESCRIPTION,
      action: TELEGRAM_CLIENT_UNSUPPORTED_ACTION,
      actionHandler: () => {
        window.open(TELEGRAM_APPS, '_blank')
      }
    },
    version: {
      title: TELEGRAM_VERSION_UNSUPPORTED,
      description: TELEGRAM_VERSION_UNSUPPORTED_DESCRIPTION,
      action: TELEGRAM_VERSION_UNSUPPORTED_ACTION,
      actionHandler: {
        ios: () => {
          window.open(TELEGRAM_IOS_APP_URL, '_blank')
        },
        android: () => {
          window.open(TELEGRAM_ANDROID_APP_URL, '_blank')
        },
        default: () => {
          window.open(TELEGRAM_APPS, '_blank')
        }
      }
    }
  }
  const navigate = useNavigate();
  const { isAuthenticated, isAuthReady } = useAuth();

  const [isTelegramVersionUnsupported, setIsTelegramVersionUnsupported] = useState(false);
  const [prompt, setPrompt] = useState({
    title: '',
    description: '',
    action: '',
    actionHandler: () => { }
  })


  useEffect(() => {
    setHeaderColor(BLACK)
    const redirect = async () => {
      try {
        const platform = getPlatform()
        const version = APIVersion()
        if (platform === 'tdesktop') {
          setPrompt(UNSUPPORTED_TELEGRAM_PROMPT.client)
          setIsTelegramVersionUnsupported(true)
        } else if (versionCompare(version, MINIMUM_WEBAPP_VERSION) < 0) {
          const actionHandler = platform === 'ios' || platform === 'android'
            ? UNSUPPORTED_TELEGRAM_PROMPT.version.actionHandler[platform]
            : UNSUPPORTED_TELEGRAM_PROMPT.version.actionHandler.default
          setPrompt({
            title: UNSUPPORTED_TELEGRAM_PROMPT.version.title,
            description: UNSUPPORTED_TELEGRAM_PROMPT.version.description,
            action: UNSUPPORTED_TELEGRAM_PROMPT.version.action,
            actionHandler
          })
          setIsTelegramVersionUnsupported(true)
        } else if (!DeviceStorage.isDeviceStorageSupported() || !SecureStorage.isSecureStorageSupported()) {
          throw new Error('Secure storage is not supported')
        } else if (!isAuthReady) {
          return
        } else {
          navigate(isAuthenticated ? "/home" : "/onboarding")
        }
      } catch (error) {
        if (error instanceof Error) {
          window.alert(error?.message || t('errors.0'))
        } else {
          window.alert(t('errors.0'))
        }
      }
    }

    const redirectTimer = setTimeout(async () => {
      await redirect()
    }, 1500)

    return () => clearTimeout(redirectTimer)

  }, [navigate, isAuthenticated, isAuthReady, t])

  return (
    <SplashContainer>
      <DialogOptionBox
        isOpen={isTelegramVersionUnsupported}
        title={prompt.title}
        description={prompt.description}
        primaryButtonText={prompt.action}
        secondaryButtonText="Contact us"
        onPrimaryClick={prompt.actionHandler}
        onSecondaryClick={() => redirectToTelegramSupport('JagadCS_bot')}
      />
      <JagadLogo type="logo-white-text-white" />
      <Website>
        www.thejwallet.com
      </Website>
      <BetaLabel />
    </SplashContainer>
  );
};

export default SplashScreen;
